import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SiselsePerson } from 'src/app/interfaces/siselse';

@Component({
  selector: 'siselse-person',
  template: `
    <ion-item>
      <ion-input [(ngModel)]="person.nombrecondomino" placeholder="Nombre"></ion-input>
      <ion-input [(ngModel)]="person.apellidopcondomino" placeholder="Apellido Paterno"></ion-input>
      <ion-input [(ngModel)]="person.apellidomcondomino" placeholder="Apellido Materno"></ion-input>
     
      <ion-button color="white" slot="end" *ngIf="person.tipocondomino !== '1'" (click)="deletePerson.emit()"><ion-text color="danger">Eliminar</ion-text> <ion-icon color="danger" name="trash" slot="end"></ion-icon></ion-button>
      
    </ion-item>
  `,
})
export class SiselsePersonComponent {
  @Input() person: SiselsePerson;
  @Output() deletePerson = new EventEmitter<void>();
}